import { useEffect } from 'react';

const checkCcmReady = () => {
  let x = 0;
  const interval = setInterval(() => {
    x += 1;
    if (window.ccm && !window.ccm.hasAnswered()) {
      clearInterval(interval);
      window.scrollTo(0, 0);
    }
    if (x === 100) {
      clearInterval(interval);
    }
  }, 300);

  return interval;
};

const useScrollToCookieConsentModule = () => {
  useEffect(() => {
    const interval = checkCcmReady();
    return () => {
      clearInterval(interval);
    };
  }, []);
};

export default useScrollToCookieConsentModule;
